import { FetchUnknownUserTemplateQuery, FetchUnknownUserTemplateQueryVariables } from 'es/app/__generated__/global';
import { IAccessGroup } from 'es/app/business-logic/domain-models/AccessGroup';
import Site from 'es/app/business-logic/domain-models/Site';
import { FETCH_UNKNOWN_USER_TEMPLATE } from 'es/app/views/system/sso-user-templates/graphql/system.fetchUnknownUserTemplate';
import LogManager from 'es/core/logging/LogManager';
import ApolloProvider from 'es/core/net/ApolloProvider';
import Guid from 'es/core/types/Guid';

const logger = LogManager.getLogger('fetchUnknownUserTemplate');

export async function fetchUnknownUserTemplate(id: Guid) {
    const { data, errors } = await ApolloProvider.system.query<
        FetchUnknownUserTemplateQuery,
        FetchUnknownUserTemplateQueryVariables
    >({
        query: FETCH_UNKNOWN_USER_TEMPLATE,
        variables: {
            id,
        },
    });

    const result = data.system.unknownUserTemplates.at(0);

    if (!result) {
        const errorMessage = `Failed to get unknown user template with id: ${id}`;
        logger.error(errorMessage, errors);
        throw new Error(errorMessage);
    }

    const accessGroups: Array<IAccessGroup> = result.accessGroups.map(
        ({ accessGroup: { description, id, isInheritable, name, parent }, authDomain }) => ({
            description,
            id,
            isInheritable,
            name,
            owner: Site.get(authDomain.companyAlias, authDomain.facilityAlias),
            parentId: parent?.id,
        })
    );

    return { ...result, accessGroups };
}
